import type {
	SettingValueType,
	SettingValue,
	SettingsContribution,
	SettingsPreset,
	StoredSettings
} from './types.js'
import {
	registerSettings,
	registerPreset,
	get,
	set,
	reset,
	getPresets,
	getActivePreset,
	getUserValues,
	applyPreset,
	setActivePresetId,
	clearPreset,
	resetAll,
	exportJSON,
	importJSON
} from './settings-service.svelte.js'

export function useSettings() {
	const presetsValue = $derived(getPresets())
	const activePresetValue = $derived(getActivePreset())
	const userValuesValue = $derived(getUserValues())

	return {
		get presets() {
			return presetsValue
		},
		get activePreset() {
			return activePresetValue
		},
		get userValues() {
			return userValuesValue
		},
		registerSettings(contribution: SettingsContribution) {
			registerSettings(contribution)
		},
		registerPreset(preset: SettingsPreset) {
			registerPreset(preset)
		},
		applyPreset(presetId: string) {
			applyPreset(presetId)
		},
		setActivePresetId(presetId: string | null) {
			setActivePresetId(presetId)
		},
		clearPreset() {
			clearPreset()
		},
		resetAll() {
			resetAll()
		},
		get<T extends SettingValueType>(key: string) {
			return get<T>(key)
		},
		set(key: string, value: unknown) {
			set(key, value)
		},
		reset(key: string) {
			reset(key)
		},
		exportJSON(): string {
			return exportJSON()
		},
		importJSON(jsonStr: string) {
			return importJSON(jsonStr)
		}
	}
}
